import React from 'react';

import { flagStyles } from '../settings';

const SvgBE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-432px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBE;
